"use strict";

exports.__esModule = true;
var _payment = require("./payment/payment");
Object.keys(_payment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _payment[key]) return;
  exports[key] = _payment[key];
});
var _service = require("./service/service");
Object.keys(_service).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _service[key]) return;
  exports[key] = _service[key];
});
var _duration = require("./duration/duration");
Object.keys(_duration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _duration[key]) return;
  exports[key] = _duration[key];
});
var _activeFeature = require("./activeFeature/activeFeature");
Object.keys(_activeFeature).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _activeFeature[key]) return;
  exports[key] = _activeFeature[key];
});
//# sourceMappingURL=index.js.map